import axios from "axios";
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
const IMAGE_UPLOAD_URL = process.env.REACT_APP_CLOUDINARY_IMAGE_UPLOAD_URL;
const VIDEO_UPLOAD_URL = process.env.REACT_APP_CLOUDINARY_VIDEO_UPLOAD_URL;
const TESTIMONIAL_VIDEO_SIZE =
  Number(process.env.REACT_APP_TESTIMONIAL_VIDEO_SIZE) || 25;

// console.log("IMAGE_UPLOAD_URL", IMAGE_UPLOAD_URL);

// upload image (simple, no progress)
const uploadToCloudinary = async (file) => {
  if (!file) return null;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  try {
    const res = await axios.post(IMAGE_UPLOAD_URL, formData);
    return res.data.secure_url;
  } catch (err) {
    console.error("Cloudinary upload failed:", err);
    throw new Error("Cloudinary upload failed");
  }
};

//  upload video (with size validation + progress tracking)
export const uploadVideoToCloudinary = async (file, onProgress = () => {}) => {
  if (!file) throw new Error("No file provided for upload");

  // Validate file size
  const fileSizeMB = file.size / (1024 * 1024);
  if (fileSizeMB < 1) {
    throw new Error("Video is too small. Minimum size is 1MB.");
  }
  if (fileSizeMB > TESTIMONIAL_VIDEO_SIZE) {
    throw new Error(
      `Video is too large. Maximum size is ${TESTIMONIAL_VIDEO_SIZE} MB.`,
    );
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  try {
    const res = await axios.post(VIDEO_UPLOAD_URL, formData, {
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          onProgress(percent); // callback for UI
        }
      },
    });

    return res.data.secure_url;
  } catch (err) {
    console.error("Cloudinary video upload failed:", err);
    throw new Error("Cloudinary video upload failed");
  }
};

export default uploadToCloudinary;
